<ng-container *ngIf="wasteConfigJson">
  <form *ngIf="wasteConfigJson" class="wrapperForm"><br>
    <span>{{'WasteReductionMsg' | translate}}</span><br />
    <div id="wasteReductionPage">
      <mat-tab-group #tabGroup>
        <mat-tab *ngFor="let type of wasteRednType; index as index" [label]="getTranslate(type)">
          <div>
            <app-table [tableLevelReportCtl]="wasteReductionForm.get('tableLevelReport')['controls'][index]"
              [activity]="activity" [wasteReductionobj]="wasteConfigJson[type]"
              [reportSubmissionId]="reportSubmissionId" [activityForm]="activityForm"></app-table>
          </div>
        </mat-tab>
      </mat-tab-group>
      <div class="grandTotalWrapper">
        <p class="grandTotal_txt">{{'GrandTotalLabel' | translate}}</p>
        <p class="totalDiv">{{wasteReductionForm.get('totalEstimatedReport').value }} MTCO2e</p>
      </div>
    </div>
    
  </form>
</ng-container>
<div *ngIf="imgHelpDialog" class="imgOverlay">
  <div class="img-modal">
    <div class="modal-close-btn">
      <img class="close-btn" src="../assets/images/dialog-close.png" (click)="closeImageModal()" alt="">
    </div>
    <img class="help-img" [src]='activity.imagePath' alt="">

  </div>
</div>
